import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-sb-effecten',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tekst-effecten.component.html',
  styleUrl: './tekst-effecten.component.scss',
})
export class TekstEffectenComponent {}
